import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Text from "@/core/components/ui/general/Text.vue";

const __default__ = {
  name: "BackButton",
};


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  label: {
    type: String,
    default: "",
  },
  isBgTransparent: Boolean,
},
  emits: ["on-back"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emits = __emit;
const onHandleBack = () => {
  emits("on-back");
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["back-button tw-bg-white tw-h-[24px] tw-flex tw-items-center tw-justify-center tw-rounded-[42px]", { '!tw-bg-transparent !tw-px-0 !tw-shadow-none': __props.isBgTransparent }])
  }, [
    _createVNode(_component_v_btn, {
      "prepend-icon": "mdi-chevron-left",
      variant: "plain",
      onClick: onHandleBack
    }, {
      default: _withCtx(() => [
        _createVNode(Text, { variant: "span" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.label), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 2))
}
}

})